import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { OpportunityProbabilityClient, OpportunityProbabilityView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OpportunityProbabilityService {
    constructor(private readonly client: OpportunityProbabilityClient) {}

    async getAll(): Promise<OpportunityProbabilityView[]> {
        return await lastValueFrom(this.client.opportunityProbabilityGetAll());
    }
}
